import React, { Suspense } from "react";
import Stepper from "../OptimaSecure/Components/Stepper";
import { FormContextProvider } from "../../Contexts/FormContextProvider";
import useGoDigitCQ from "./useGoDigitCQ";
import Loading from "../../Components/Loading";
import CategoryHeader from "./../../../Components/Headers/CategoryHeader";

const GoDigitCQ = (props) => {
  const {
    transferData,
    onBack,
    onSubmit,
    finalData,
    loading,
    CurrentStep,
    stepsLabel,
    activeStep,
    handleStepClick,
  } = useGoDigitCQ(props);

  return (
    <FormContextProvider
      value={{
        onSubmit,
        onBack,
        values: finalData,
        transferData,
        loading,
      }}
    >
      <CategoryHeader title="Health Insurance" />
      <Stepper
        steps={stepsLabel}
        activeStep={activeStep}
        onClick={handleStepClick}
      />
      <Suspense fallback={<Loading />}>
        <CurrentStep />
      </Suspense>
    </FormContextProvider>
  );
};

export default GoDigitCQ;
